<template>
  <v-container
    id="detalhe-valor-pagar-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :url="link"
        />
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card
                  class="mx-auto"
                  outlined
                >
                  <v-list-item three-line>
                    <v-list-item-content
                      id="listItemMovimentacao"
                      class="pr-10"
                      :style="dynamicPadding"
                    >
                      <div class="text-overline mb-4 highlighted-item">
                        Detalhamento Fluxo de Caixa contas a receber em atraso à 7 dias
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-container>
                    <v-row
                      v-if="enableBtnPrint"
                      id="btnPrint"
                    >
                      <v-btn
                        class="col-4 col-sm-3 col-md-1 col-lg-1"
                        small
                        :color="corPrimaria"
                        dark
                        :loading="imprimindo"
                        @click="imprimir()"
                      >
                        <v-icon>
                          mdi-printer
                        </v-icon>
                        Imprimir
                        <template v-slot:loader>
                          <span>Imprimindo...</span>
                        </template>
                      </v-btn>
                    </v-row>
                  </v-container>
                  <v-card-actions>
                    <v-row v-if="loading">
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div
                          :style="styleObject"
                          class="text-center"
                        >
                          <v-icon
                            light
                            class="custom-loader"
                            :style="styleObject"
                          >
                            mdi-cached
                          </v-icon>
                          Carregando dados...
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-else-if="error">
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div
                          class="alert alert-danger"
                        >
                          {{ error }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <v-data-table
                          id="headers"
                          :headers="headersDetalhamento"
                          :items="dadosDetalhamento"
                          :items-per-page="dadosDetalhamento.length"
                          fixed-header
                          disable-sort
                          hide-default-footer
                          class="elevation-1"
                          style="color: black"
                        />
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import FluxoCaixa from '../../../../../services/fluxocaixa2'
  import eventEmit from '../../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardFluxoCaixa2DetalheReceberEmAtraso',
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectValorPago: {
        color: '#4780b8',
      },
      styleObjectValorAberto: {
        color: '#f27686',
      },
      styleObjectIcon: {
        color: '#4780b8',
      },
      enablePrimeiroDia: false,
      enableUltimoDia: false,
      enableEmpresa: true,
      paginaEnable: false,
      link: localStorage.linkContasPagar,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      headersDetalhamento: [
        { text: 'Data', value: 'data', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', class: 'black--text title' },
        { text: 'Valor Em Atraso', value: 'recebimento', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableBtnPrint: false,
      imprimindo: false,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select

        this.updateDate()
      },

      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPadding = 'padding-right: 100rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPadding = 'padding-right: 65rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPadding = 'padding-right: 1rem !important'
        } else {
          this.dynamicPadding = 'padding-right: 60rem !important'
        }
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.showDadosDelhamento()
      },

      async showDadosDelhamento () {
        this.loading = true
        this.enableBtnPrint = false

        await FluxoCaixa.showDadosDelhamentoReceberEmAtraso(localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosMovimentacao.map((item) => {
              var listaDetalhamento = ({
                data: item.data,
                cliente: item.nome,
                recebimento: parseFloat(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDetalhamento
            })

            this.enableBtnPrint = true
          } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      async imprimir () {
        try {
          this.loadingPrint = true
          this.imprimindo = true

          await this.executarImpressao()
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        } finally {
          this.loadingPrint = false
          this.imprimindo = false
        }
      },

      async executarImpressao () {
        return new Promise(resolve => {
          setTimeout(() => {
            this.print(10)

            resolve()
          }, 3000)
        })
      },

      async print (posYFiltros) {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 2
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: posY,
              styles: { fontSize: 10 },
            })

            posY = 20

            return posY
          }

          const titleTableMovimentacao = 'Detalhamento Fluxo de Caixa contas a receber em atraso à 7 dias'

          const tableTableMovimentacao = this.dadosDetalhamento.map(item => [item.data, item.cliente, item.recebimento])

          await addTable(tableTableMovimentacao, this.headersDetalhamento, titleTableMovimentacao, posYFiltros, 8)

          // Salvar o PDF
          pdf.save('relatorio_fluxo_caixa_contas_receber_em_atraso.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.loadingPrint = false
        }
      },
    },
  }
</script>
<style lang="sass">
  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemMovimentacao
    margin: -2rem 0 0 -1rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
